import { render, staticRenderFns } from "./BusinessAccommodationMainSection.vue?vue&type=template&id=0f12d299"
import script from "./BusinessAccommodationMainSection.vue?vue&type=script&lang=js"
export * from "./BusinessAccommodationMainSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports